import { render } from "./EmrCalculator.vue?vue&type=template&id=7913ff4a"
import script from "./EmrCalculator.vue?vue&type=script&lang=js"
export * from "./EmrCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__